const facets = {
	init: () => {
		facets.events();

		facets.resize();
		$(window).on('resize', () => facets.resize());
	},

	resize: () => {
		if($(window).width() > 1024) {
			$('.facets').addClass('open');
			$('.facet-toggle').attr('aria-expanded', 'true');
		} else {
			$('.facets').removeClass('open');
			$('.facet-toggle').attr('aria-expanded', 'false');
		}
	},

	events: () => {
		$(document).on('click', '.facet-toggle', function(e) {
			e.preventDefault();
			const $this = $(this);
			const $parent = $this.closest('.facets');
			if($parent.hasClass('open')) {
				$parent.removeClass('open');
				$this.attr('aria-expanded', 'false');
			} else {
				$parent.addClass('open');
				$this.attr('aria-expanded', 'true');
			}
		});

		$(document).on('click', '.filters .filter  h3', function(e) {
			e.preventDefault();
			
			const $filter = $(this).closest('.filter');
			if($filter.hasClass('open')) {
				$filter.removeClass('open').find('.filter__values').slideUp(200);
				$filter.find('.filter__values').css('left', '0px');
			} else {

				$('.filters .filter').removeClass('open').find('.filter__values').slideUp(200).css('left', '-1px');
				$filter.addClass('open').find('.filter__values').slideDown(200);

				//when open if the .filter__values extend beyond the viewport width, update the left position until it fits
				const $values = $filter.find('.filter__values');
				const leftPos = $values.offset().left;
				const valuesWidth = $values.outerWidth();
				const viewportWidth = $(window).width();

				if(leftPos + valuesWidth > viewportWidth) {
					const offset = viewportWidth - (leftPos + valuesWidth);
					$values.css('left', offset + 'px'); // move it to the left
				} else {
					$values.css('left', '0px'); // reset if it fits
				}
			}
		})

		$(document).on('click', function(e) {
			if(!$(e.target).closest('.filters .filter').length) {
				console.log('click outside');
				$('.filters .filter').removeClass('open').find('.filter__values').slideUp(200);
			}
		});

		$(document).on('change', '.filter__values input[type="checkbox"]', function(e) {
			const $this = $(this);
			const filterName = $this.attr('name');
			const filterValue = $this.val();
			const isChecked = $this.is(':checked');

			if(isChecked) {
				facets.updateUrl(filterName, filterValue);
			} else {
				facets.updateUrl(filterName, null);
			}

			facets.fetchResults(window.location.href);
		});

		$(document).on('click', '.active-facet', function(e) {
			e.preventDefault();

			const $this = $(this);
			const url = $this.attr('href');
			window.history.pushState({}, '', url.toString());

			facets.fetchResults(window.location.href);
		});
	},

	updateUrl: (param, value) => {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);

		// url needs to append all parameters and values, even if they already exist. So if you have the parameter 't' being passed in with the valye 'a' you get t=a. If t is set again as 'b' later we need the url to be t=a&t=b
		if(value) {
			if(searchParams.has(param)) {
				const existingValues = searchParams.getAll(param);
				existingValues.push(value);
				searchParams.delete(param); // remove existing values
				existingValues.forEach(val => searchParams.append(param, val)); // re-add all values
			} else {
				searchParams.append(param, value);
			}
		} else {
			searchParams.delete(param); // remove the parameter if value is null
		}
		
		url.search = searchParams.toString();
		window.history.pushState({}, '', url.toString());
	},

	fetchResults: (url) => {
		$('.collection-product-grid-container').addClass('loading');

		return fetch(url)
			.then(response => response.text())
			.then(html => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');

				const productGrid = doc.querySelector('#product-grid');
				console.log('productGrid', productGrid);
				if(productGrid) {
					document.querySelector('#product-grid').innerHTML = productGrid.innerHTML;
				}
				
				const facetsContainer = doc.querySelector('.facets');
				if(facetsContainer) {
					document.querySelector('.facets').innerHTML = facetsContainer.innerHTML;
				}

				const pagination = doc.querySelector('.pagination-wrapper');
				if(pagination) {
					document.querySelector('.pagination-wrapper').innerHTML = pagination.innerHTML;
				}

				$('.collection-product-grid-container').removeClass('loading');
			})
			.catch(error => console.error('Error fetching results:', error));
	}
}

jQuery(() => {
	if($('.facets').length) facets.init();
})